import { createAction, createSlice } from "@reduxjs/toolkit";
import { BasicGasCalculation, GasCalculationData } from "../../model/calculations/calculation";

interface GasCalculationState {
    loading: boolean;
    error: string | null;
    basicGasCalculation: BasicGasCalculation | null;
    gasIntakeData: GasCalculationData | null;
    GasCalculationComplete: boolean;
    showOutput: boolean;
};

export const initialState: GasCalculationState = {
    loading: false,
    error: null,
    basicGasCalculation: null,
    gasIntakeData: null,
    GasCalculationComplete: false,
    showOutput: false,
};

export const gasCalculationStart = createAction("jetlift/gasCalculations/gasCalculationStart");

const GasCalculationSlice = createSlice({
    name: "jetlift/gasCalculations",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action?.payload;
        },
        setError: (state, action) => {
            state.error = action?.payload;
        },
        setBasicGasCalculation: (state, action) => {
            state.basicGasCalculation = action?.payload;
        },
        setGasIntakeData: (state, action) => {
            state.gasIntakeData = action?.payload;
        },
        setGasCalculationComplete: (state, action) => {
            state.GasCalculationComplete = action?.payload;
        },
        setShowOutput: (state, action) => {
            state.showOutput = action?.payload;
        },
    }
});

export const {
    setLoading,
    setError,
    setBasicGasCalculation,
    setGasIntakeData,
    setGasCalculationComplete,
    setShowOutput,
} = GasCalculationSlice?.actions;

export default GasCalculationSlice?.reducer;